import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'
import { GetLaborerEToIRequestByIdResponse } from 'api/laborerPortalAPI/newDlTransferApi'
import { LaboerEtoIRequestDetails } from 'common/types/commonTypes'
import { formatNationalityFromBE, formatOccupationsFromBE } from 'common/utils/objectWithTranslation'

type State = {
  request?: LaboerEtoIRequestDetails
} & Status

const initialState: State = {
  request: undefined,
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_ASYNC,
    Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_SUCCESS,
    Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_FAIL,
    GetLaborerEToIRequestByIdResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_SUCCESS: {
      const { data } = action.payload
      return {
        ...state,
        ...action.status,
        request: {
          id: data.id,
          status: data.status,
          createdAt: data.created_at,
          laborerIdNumber: data.laborer_id_number,
          laborerPassportNumber: data.laborer_passport_number,
          laborerName: data.laborer_name,
          laborerGender: data.laborer_gender,
          laborerBirthDate: data.laborer_birth_date,
          laborerSalary: data.laborer_salary,
          laborerCurrentOccupation: formatOccupationsFromBE(data.laborer_current_occupation),
          laborerNationality: formatNationalityFromBE(data.laborer_nationality),
          laborerNewOccupation: formatOccupationsFromBE(data.laborer_new_occupation),
          employer: {
            idNumber: data.employer.id_number,
            name: data.employer.name,
            email: data.employer.email,
            mobile: data.employer.mobile,
          },
        },
      }
    }
    case Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_ASYNC:
    case Actions.GET_LABORER_E_TO_I_REQUEST_BY_ID_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
